export default class MenuSurface {
}
//# sourceMappingURL=index.js.map